export class Subscription {

    // constructor() {}

    lead(e,obj)
    {

        e.preventDefault()
        let _this = this
        let start = performance.now()
		let loader = document.querySelector('form.mailing-card__form > .form__loader')
		loader.classList.add('active')

		$.ajax({
			url: "/ajax.php?mid=10",
			type: 'POST',
            data: {
                action: 'subscription',
                email: obj.email.value,
            },
            dataType: "json",
			success: function(res){
                if(res['error']) {
                    alert(res['error'])
                } else {
                    let form = document.querySelector('form.mailing-card__form > .form__main')
                    let formSuccess = document.querySelector('form.mailing-card__form > .form__success')
                    _this.prepareTime(form,formSuccess,loader,start)
                }
			},
			error: function(error){
				alert('Ошибка отправки данных! Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта')
			}			
		})

    }

    showSuccess(form,formSuccess,loader) {
        form.style.display = 'none'
        formSuccess.style.display = 'block'
        loader.classList.remove('active')
    }

    prepareTime(form,formSuccess,loader,start) {
        let _this = this
        let end = performance.now()
        let time = end - start
        if(time < 200) {
            time = 200 - time
            setTimeout(function(){_this.showSuccess(form,formSuccess,loader)}, time);
        } else {
            this.showSuccess(form,formSuccess,loader)
        }
    }

}